import React from "react";
import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

const CategoryAlertPending = ({ categoryPending, requestColumn }) => {

  return (
    <div>
      <Box
        sx={{
          flexGrow: 1,
          maxWidth: { xs: 650, sm: 682, lg: 1350 },
          bgcolor: "background.paper",
        }}
      >
        <DataGrid
          rows={categoryPending}
          columns={requestColumn}
          disableSelectionOnClick
          pageSizeOptions={[25, 50, 100]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 25,
              },
            },
          }}
        />
      </Box>
    </div>
  );
};

export default CategoryAlertPending;
